
import './App.css';
import { useState } from 'react';
import { i18n } from './translate/i18n';
import Navbar from './pages/navbar/Navbar';
import Home from './pages/home/Home';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Unidade from './pages/unidade/Unidade';
import Footer from './pages/footer/Footer';

const I18N_STORAGE_KEY = 'i18nextLng';

const App = () => {

    const [language] = useState(localStorage.getItem(I18N_STORAGE_KEY));

    const handleSelectChange = event => {
        localStorage.setItem(
            I18N_STORAGE_KEY,
            event.target.value
        );
        window.location = window.location;
    }

    return (
        <>
            <BrowserRouter>
                <Navbar />
                <Routes>
                    <Route path='/' element={<Home />} />

                    <Route path='/unidade/:shortname' element={<Unidade />} />
                </Routes>
                <Footer />
            </BrowserRouter>
        </>
    );

}

export default App;
